import {
  DeleteOutlined, MinusOutlined, PlusOutlined,
} from '@ant-design/icons';
import {
  InputNumber,
  Radio,
} from 'antd';
import React from 'react';

function QuantityInput({
  value: qty,
  max,
  min = 0,
  disabled,
  onChange,
  className,
  useTrashIcon = false,
  size = 'small',
}) {
  const minDisabled = disabled || qty <= min;

  return (
    <>
      <style>
        {`
          .quantity-input-center input {
            text-align: center !important;
          }
        `}
      </style>
      <Radio.Group
        size={size}
        value="nothing"
        className={`${className || ''} whitespace-nowrap`}
      >
        <Radio.Button
          disabled={minDisabled}
          onClick={() => onChange(qty - 1)}
        >
          {qty === 1 && useTrashIcon ? <DeleteOutlined /> : <MinusOutlined />}
        </Radio.Button>
        <InputNumber
          size={size}
          min={1}
          style={{
            width: '50px',
            textAlign: 'center',
            borderRadius: 0,
            borderLeft: 'none',
            borderRight: 'none',
          }}
          controls={false}
          placeholder="1"
          value={qty}
          onChange={(value) => onChange(value)}
          inputMode="numeric"
          className="quantity-input-center"
        />
        <Radio.Button
          disabled={disabled || qty >= max}
          onClick={() => onChange(qty + 1)}
        >
          <PlusOutlined />
        </Radio.Button>
      </Radio.Group>
    </>
  );
}

export default QuantityInput;
